import { useEffect, useState } from 'react';

export const useFetch = (url: string, skip: boolean) => {
  const [data, setData] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  let isCancelled = false;
  const fetchData = async (uri: string) => {
    if (skip) {
      return;
    }
    setLoading(true);
    setError(false);
    try {
      const response = await window.fetch(uri, { mode: 'cors' });
      const responseJson = await response.json();
      if (!isCancelled) {
        setData({ ...responseJson });
        setLoading(false);
      }
    } catch (e) {
      if (!isCancelled) {
        setError(true);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    return () => {
      isCancelled = true;
    };
  }, []);

  useEffect(() => {
    fetchData(url);
  }, [url]);

  return { data, loading, error, fetch: fetchData };
};
